import { Box, Container, Grid, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { FullTextContent, VideoHeader } from 'templates/retail-energy';
import { FullTextContentProps } from './FullTextContent';
import { VideoHeaderProps } from './VideoHeader';

interface VideoFullTextSectionProps {
  className?: string;
  textSection: FullTextContentProps;
  contentSection: VideoHeaderProps;
  reverse?: boolean;
  simpleVideo?: string;
}

const useStyles = makeStyles({
  video: {
    width: '100%',
    maxWidth: 1000,
    margin: '0 auto',
    display: 'block',
  },
});

const VideoFullTextSection: FC<VideoFullTextSectionProps> = ({
  className,
  contentSection,
  textSection,
  simpleVideo,
  reverse,
}) => {
  const classes = useStyles();
  return (
    <Box className={className}>
      <Grid container>
        <Grid item xs={12}>
          {simpleVideo ? (
            <Container fixed>
              <video className={classes.video} src={simpleVideo} autoPlay muted loop />
            </Container>
          ) : (
            <VideoHeader
              imageSrcset={contentSection.imageSrcset}
              videoSrcset={contentSection.videoSrcset}
              className={contentSection.className}
            />
          )}
        </Grid>
        <Grid item xs={12} style={{ order: reverse && -1 }}>
          <FullTextContent
            title={textSection.title}
            text={textSection.text}
            className={textSection.className}
            link={textSection.link}
            reverse={reverse}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VideoFullTextSection;
